import digitalData from 'digital-data';
import { getState, selectState, setState } from '../../../analytics-state';
import {
  PEP,
  PAGE_AB_TEST,
  BROWSE,
  PRODUCTS_AVAILABILITY,
  PLP_GRID,
  NUCLEUS,
  NO_EVENT,
  PAGINATION,
  FILTER,
  SORT,
} from '../../../constants';
import {
  getContentProducts,
  setAnalytics,
  getProductAnalytics,
  getCategoryBreadCrumbs,
  getCurrentPage,
  shouldReInitAnalytics,
  getFilters,
  getDomainList
} from '../../../thd-analytics-utils';
import { nextDataSource } from '../../../generators/dataSources';

export function pep() {

  const { take } = LIFE_CYCLE_EVENT_BUS.effects;
  let cachedPepModel;
  let cachedProduct;

  const initPEP = (productPromise, browsePromise) => {
    Promise.all([productPromise, browsePromise]).then((dataList) => {

      if (dataList?.length < 2) return;
      const assignedData = dataList.reduce((acc, data, index) => {
        const newAcc = acc;
        newAcc[data?.__typename || index] = data;
        return newAcc;
      }, {});

      const { BaseProduct: product, SearchModel: pepModel } = assignedData;
      const { breadCrumbs = [] } = product?.taxonomy || {};
      const { products, searchReport, metadata } = pepModel || {};

      const {
        startIndex,
        pageSize,
        sortOrder,
        sortBy
      } = searchReport || {};

      const { pageType = '', pageTransitionEvent = NO_EVENT } = getState() || {};

      if (products?.length) {
        digitalData.content = {
          ...digitalData.content,
          product: getContentProducts(products, pageType) || [],
          feature: {
            plpModule: products?.length ? 'y' : 'n'
          }
        };
      }

      setState({
        ...getState(),
        pageTransitionEvent: undefined
      });

      if (!shouldReInitAnalytics(pageTransitionEvent)) {
        if (pageTransitionEvent === FILTER) {
          LIFE_CYCLE_EVENT_BUS.trigger('filters-refinements.publish', {
            breadCrumbs: pepModel?.taxonomy?.breadCrumbs,
            searchReport,
            metadata
          });
        } else if (pageTransitionEvent === SORT) {
          LIFE_CYCLE_EVENT_BUS.trigger('sort-refinements.publish');
        }
        return;
      }

      digitalData.page = {
        pageInfo: {
          pageName: 'product entry page>' + product?.identifiers?.itemId,
          pageLoadEvent: pageTransitionEvent === PAGINATION ? PAGINATION : 'pep view',
          pageType: PEP,
          platform: NUCLEUS,
          abTest: PAGE_AB_TEST
        },
        category: getCategoryBreadCrumbs(breadCrumbs) || {},
        displayAttributes: {
          pageNumber: getCurrentPage(startIndex, pageSize),
          productsAvailability: PRODUCTS_AVAILABILITY,
          sortBy,
          viewType: PLP_GRID
        },
        filter: getFilters({ appliedDimensions: pepModel?.appliedDimensions })
      };

      // let serviceAddons; // Todo: Kalee killed the service addons, will fix it
      // if (info.hasServiceAddOns) {
      //   serviceAddons = yield selectState('dataSources.serviceAddons', { timeout: 3000 });
      // }

      digitalData.product = getProductAnalytics({
        product
      });

      digitalData.event = digitalData.event || [];

      setAnalytics(digitalData);
    });
  };

  const browsePromise = ({ skipBrowse = false } = {}) => {
    if (skipBrowse) return new Promise((res) => res(cachedPepModel));
    return new Promise((resolve) => {
      LIFE_CYCLE_EVENT_BUS.lifeCycle.off('pep.new-products');
      LIFE_CYCLE_EVENT_BUS.lifeCycle.on('pep.new-products', ({ output: browseModel }) => {
        resolve(browseModel);
        cachedPepModel = browseModel;
      });
    });
  };

  const productPromise = ({ skipProduct = false } = {}) => {
    if (skipProduct) return new Promise((res) => res(cachedProduct));
    return new Promise((resolve) => {
      window.LIFE_CYCLE_EVENT_BUS.runEventSequence(function* initPep() {
        while (true) {
          const response = yield take('pep.pip-ready');
          const itemId = response?.output?.itemId;

          if (itemId) {
            const allProducts = yield selectState('dataSources.product', { timeout: 100 });
            const productData = allProducts?.[itemId]?.product;
            if (productData) {
              resolve(allProducts?.[itemId]?.product);
              cachedProduct = allProducts?.[itemId]?.product;
              break;
            }
          }
          const { output: productRequest } = yield nextDataSource('product', {
            domains: getDomainList(),
            timeout: 5000
          });
          resolve(productRequest?.data?.product || cachedProduct);
          cachedProduct = productRequest?.data?.product;
          break;
        }
      });
    });
  };

  initPEP(productPromise(), browsePromise());

  const onEventClick = ({ skipProduct = false, skipBrowse = false } = {}) => {
    initPEP(productPromise({ skipProduct }), browsePromise({ skipBrowse }));
  };

  window.LIFE_CYCLE_EVENT_BUS.on('pagination.click', () => {
    onEventClick({ skipProduct: true });
  });
  window.LIFE_CYCLE_EVENT_BUS.on('filters-refinements.click', () => {
    onEventClick({ skipProduct: true });
  });
  window.LIFE_CYCLE_EVENT_BUS.on('sort-refinements.click', () => {
    onEventClick({ skipProduct: true });
  });
  window.LIFE_CYCLE_EVENT_BUS.on('super-sku.click-swatch', () => {
    onEventClick({ skipBrowse: true });
  });
}
